<app-modal #successModal [modalConfig]="modalConfig">
  <div class="modal-body text-center py-5">
    <div class="success-icon-container mb-4">
      <div class="host-offers separator-right" i18n>
        <img class="icon" src="assets/images/icons/Check.svg" alt="Success" />
      </div>
    </div>
    <h2 class="success mb-4">
      <p i18n>Success</p>
    </h2>
    <p class="success-message mb-4" i18n
      >Your message is on its way to your Consultant. They will be in touch soon.</p
    >
    <button type="button" class="btn btn-success btn-continue" (click)="onClose()" i18n>
      {{ buttonText }}
    </button>
  </div>
</app-modal>
